// extracted by mini-css-extract-plugin
module.exports = {"tp35a5n":"tp35a5n","rqwyzr9":"rqwyzr9"};